import { useBookingDetails } from "@repo/store/slices";

export const usePassengerName = () => {
  const bookingDetails = useBookingDetails();

  return (passengerKey: string): string => {
    const paxDetails = bookingDetails?.passengers?.[passengerKey];

    const fullName =
      paxDetails?.name?.first || paxDetails?.name?.last
        ? `${paxDetails.name.first ?? ""} ${paxDetails.name.last ?? ""}`.trim()
        : "";

    return fullName;
  };
};
